import { ColumnConfig, CustomerReturnsAllColumnKey } from '../../model';

export const customerReturnsConfig: Record<
  CustomerReturnsAllColumnKey,
  ColumnConfig
> = {
  returnOrderNo: { name: 'Return Order No.', field: 'multiLine' },
  debitNote: { name: 'Debit Note' },
  returnCoNo: { name: 'Return CO No.' },
  date: {
    name: 'Submitted Date',
    sortField: 'date',
  },
  status: {
    name: 'Status',
    field: 'multiLine',
  },
  returnAmt: {
    name: 'Return Goods Value ',
    sortField: 'grossTotal',
    alignment: 'flex-end',
  },
  batchCount: {
    name: 'Batch Count',
    sortField: 'batchCount',
    alignment: 'center',
  },
  cfaName: {
    name: 'CFA Name',
    field: 'avatarNameStatus',
  },
  headDivisionName: {
    name: 'Header Division',
  },
  download: {
    name: '',
    alignment: 'flex-end',
  },
};
